export default __webpack_public_path__ + "static/media/upload.b7325955.jpg";